import { render, staticRenderFns } from "./CarouselCard.vue?vue&type=template&id=4bcb469e&scoped=true&"
import script from "./CarouselCard.vue?vue&type=script&lang=js&"
export * from "./CarouselCard.vue?vue&type=script&lang=js&"
import style0 from "./CarouselCard.vue?vue&type=style&index=0&id=4bcb469e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcb469e",
  null
  
)

export default component.exports